<template>
    <div class="logo">
        <router-link :to="url">
            <img class="logo-dark" :src="logo" alt="船水技术"/>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Logo',
        props: {
            url: {
                type: String,
                default: '/'
            },
            logo: {
                type: String,
                default: function () {
                    return require(`@/assets/images/logo.png`)
                }
            }
        }
    }
</script>
